import { render, staticRenderFns } from "./ListaArquivosInteracao.vue?vue&type=template&id=1cdfe02d&scoped=true&"
import script from "./ListaArquivosInteracao.vue?vue&type=script&lang=js&"
export * from "./ListaArquivosInteracao.vue?vue&type=script&lang=js&"
import style0 from "./ListaArquivosInteracao.vue?vue&type=style&index=0&id=1cdfe02d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdfe02d",
  null
  
)

export default component.exports